/**
 * @license lucide-react v0.570.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  [
    "path",
    {
      d: "M13 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.36",
      key: "1shsnm"
    }
  ],
  ["path", { d: "M19 12v6", key: "kflna4" }],
  ["path", { d: "M19 14h2", key: "wp2qbk" }],
  ["circle", { cx: "19", cy: "20", r: "2", key: "1jfyz6" }]
];
const FolderKey = createLucideIcon("folder-key", __iconNode);

export { __iconNode, FolderKey as default };
//# sourceMappingURL=folder-key.js.map
